import axios, {AxiosError} from "axios";
import {ConfirmationOptions} from "primevue/confirmationoptions";

type Confirm = {
    require: (option: ConfirmationOptions) => void;
    close: () => void;
};
type SafeCancelParams = {
    isDirty: boolean;
    event: any;
    confirm: Confirm;
    message?: string;
};
type SafeDeleteParams = {
    event: any;
    confirm: Confirm;
    toast?: any;
    header?: string;
    toastHeader?: string;
    message?: string;
    useDialog?: boolean;
    acceptRoute: string;
    onSuccess?: () => void;
    onError?: (error: AxiosError) => void;
};
//todo if we turn this in to a vue file can we have the useConfirm() internal to this file?
export const useSafeCancel = ({isDirty, event, confirm, message}: SafeCancelParams) => {
    return new Promise((resolve, reject) => {
        if (isDirty) {
            confirm.require({
                target: event.target,
                message: message || "Unsaved changes will be lost. Proceed?",
                acceptClass: "bg-red-600 px-3 py-1.5 rounded-md confirm-cancel-yes",
                rejectClass: "px-3 py-1.5 confirm-cancel-no",
                accept: () => {
                    resolve(true);
                },
                reject: () => {
                    resolve(false);
                },
            });
        } else {
            resolve(true);
        }
    });
};

export const useSafeDelete = ({
    event,
    confirm,
    toast,
    acceptRoute,
    header,
    toastHeader,
    message,
    useDialog,
    onSuccess,
    onError,
}: SafeDeleteParams) => {
    confirm.require({
        target: event.target,
        group: useDialog ? "dialog" : undefined,
        header: header || "Are you sure you want to archive this record?",
        message: message || "It will disappear from the app.",
        acceptLabel: "Archive",
        rejectLabel: "Cancel",
        acceptClass: "bg-red-600 px-3 py-1.5 rounded-md confirm-delete-yes",
        rejectClass: "px-3 py-1.5 confirm-delete-no",
        accept: async () => {
            try {
                const {data} = await axios.delete(acceptRoute);
                if (data.status === "success") {
                    if (onSuccess) {
                        onSuccess();
                    }
                    if (toast) {
                        toast.add({
                            severity: "success",
                            summary: toastHeader ?? "Archived",
                            detail: data.message,
                            life: 3000,
                        });
                    }
                }
            } catch (error) {
                console.error("useSafeDelete error", error);
                if (onError) {
                    onError(error);
                }
                if (toast) {
                    toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "An error occurred while archiving the record",
                        life: 3000,
                    });
                }
            }
        },
        reject: () => {},
    });
};
